import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import utils from '../../utils';
import moment from 'moment';
import adminServices from '../../services/AdminServices';
import vendorServices from '../../services/VendorSevices';
import { useAuth } from '../../context/UserContext';
import { HiReceiptRefund } from "react-icons/hi";
import RefundModal from './RefundModal';
import { Link } from 'react-router-dom';
import { FaMapMarkedAlt } from "react-icons/fa";
import LocationModal from './LocationModal';
import DeliveryCodesModal from '../admin/DeliveryCodesModal';
import { HiKey } from 'react-icons/hi';


function OrderModal({ payment, onClose, isOpen, getPayments }) {
    const { user } = useAuth();
    const [status, setStatus] = useState('');
    const [deliveryStatus, setDeliveryStatus] = useState('');
    const [notes, setNotes] = useState('');
    const [loading, setLoading] = useState(false);
    const [refundAction, setRefundAction] = useState(0);
    const [selectedCartItem, setSelectedItem] = useState()

    useEffect(() => {
        if (payment) {
            setStatus(payment.status || 'Pending');
            setDeliveryStatus(payment.delivery_status || 'Ordered');
            setNotes(payment.notes || '');
        } else {
            setStatus('Pending');
            setDeliveryStatus('Ordered');
            setNotes('');
        }
    }, [payment]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!payment?.id) return;

        setLoading(true);

        const data = {
            status: status.trim(),
            delivery_status: deliveryStatus.trim(),
            notes: notes.trim() || null,
        };

        const apiCall = user?.is_vendor
            ? vendorServices.updatePayment(payment.id, data)
            : adminServices.updatePayment(payment.id, data);

        apiCall
            .then((res) => {
                toast.success('Order updated successfully!');
                setLoading(false);
                getPayments()
                onClose();
            })
            .catch((err) => {
                console.error('Update failed:', err);
                toast.error(utils.toastError || 'Failed to update order.');
                setLoading(false);
            });
    };

    if (!payment) return null;

    function refundModal(cartItem, action) {
        const openBtn = document.getElementById('refund-open-btn');
        setRefundAction(action)
        if (!(user?.is_admin || user?.is_vendor)) {
            if (cartItem?.refund?.id) {
                toast.error("Item already has a Refund Request")
                return
            }
        }
        setSelectedItem(cartItem)
        if (user?.is_admin || user?.is_vendor) {
            toast.error("Account not allowed")
            return
        }
        openBtn.click()
    }

    return (
        <div>
            <input type="checkbox" id="order-modal" className="modal-toggle" checked={isOpen} readOnly />

            <div className="modal" role="dialog">
                <div className="modal-box w-11/12 max-w-5xl max-h-[90vh] overflow-y-auto">
                    <label
                        htmlFor="order-modal"
                        className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
                        onClick={onClose}
                    >
                        ✕
                    </label>

                    <h2 className="text-2xl font-bold mb-2">Order #{payment.id}</h2>
                    <p className="text-gray-600 mb-4">
                        Ref: <code className="bg-gray-100 px-2 py-1 rounded">{payment.transaction_reference}</code>
                    </p>
                    <RefundModal
                        action={refundAction}
                        cartItem={selectedCartItem}
                        onSubmitSuccess={getPayments}
                    />
                    {(payment.cart?.delivery?.latitude && user?.is_admin) && (
                        <LocationModal
                            lat={payment.cart?.delivery?.latitude}
                            lng={payment.cart?.delivery?.longitude}
                        />
                    )}

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-6">
                        <div className="border p-3 rounded-lg shadow-sm hover:shadow-md">
                            <div className="flex gap-3 justify-between">
                                <p className="font-bold mb-1">
                                    Customer & Delivery
                                </p>
                                <Link target='_blank' to={`/payment/usr/track/${payment?.transaction_reference}/order/view`} className='btn btn-neutral btn-sm'>
                                    View Order
                                </Link>
                            </div>
                            <p><strong className='mr-2'>Customer:</strong> {payment.customer_profile?.full_name || '—'}</p>
                            <p><strong className='mr-2'>Email:</strong> {payment.customer_profile?.email || '—'}</p>
                            <p><strong className='mr-2'>Method:</strong> {payment.payment_method || '—'}</p>
                            <p><strong className='mr-2'>Created:</strong> {moment(payment.creation_time).format('lll')}</p>

                            {payment.cart?.delivery && (
                                <div className="mt-3 pt-2 border-t">
                                    <div className="flex justify-between items-center gap-3">
                                        <p><strong className='mr-2'>Delivery:</strong></p>
                                        {(
                                            payment.cart?.delivery?.latitude
                                            &&
                                            payment.cart?.delivery?.longitude
                                            &&
                                            user?.is_admin
                                        ) && (
                                                <button
                                                    onClick={() => {
                                                        document.getElementById('location-open-btn').click();
                                                    }}
                                                    className='btn btn-sm btn-neutral btn-outline'>
                                                    <FaMapMarkedAlt /> Map
                                                </button>
                                            )}
                                        {(payment?.delivery_code > 0 && user?.is_admin) && (
                                            <div>
                                                <DeliveryCodesModal
                                                    payment={payment}
                                                    accessCode={payment?.access_code}
                                                    deliveryCode={payment?.delivery_code} />
                                                <button
                                                    onClick={() => {
                                                        document.getElementById('delivery-codes-open-btn').click();
                                                    }}
                                                    className='btn btn-sm btn-neutral btn-outline'>
                                                    <HiKey /> Codes
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                    <p className='mr-2'>{payment.cart.delivery.street}, {payment.cart.delivery.city}</p>
                                    {payment.cart.delivery.notes && (
                                        <>
                                            <p className='mr-2'><strong>Notes:</strong></p>
                                            <p className=" text-gray-600">{payment.cart.delivery.notes}</p>
                                        </>
                                    )}
                                </div>
                            )}
                        </div>

                        <div className="border p-3 rounded-lg shadow-sm hover:shadow-md">
                            <p className="font-bold mb-1">Status & Totals</p>
                            <div className="pb-2 border-b">
                                <p className="">
                                    <strong className='mr-2'>Payment Status:</strong>{' '}
                                    <span className={`px-2 py-1 rounded ${payment.status === 'Paid' ? 'bg-green-100 text-green-800' : payment.status === 'Failed' ? 'bg-red-100 text-red-800' : 'bg-yellow-100 text-yellow-800'}`}>
                                        {payment.status}
                                    </span>
                                </p>
                                <p>
                                    <strong className='mr-2'>Delivery:</strong>{' '}
                                    <span className={`px-2 py-1 rounded ${payment.delivery_status === 'Delivered' ? 'bg-green-100' : payment.delivery_status === 'Shipped' ? 'bg-blue-100' : 'bg-gray-100'}`}>
                                        {payment.delivery_status}
                                    </span>
                                </p>
                            </div>
                            <div className='pt-2'></div>
                            {payment?.mpesa_recept_number && (
                                <p><strong className='mr-2'>MPESA Receipt:</strong> {payment?.mpesa_recept_number}</p>
                            )}
                            <p ><strong className='mr-2'>Items Total:</strong> KES {parseFloat(payment.items_total || 0).toLocaleString()}</p>
                            <p><strong className='mr-2'>Delivery Total:</strong> KES {parseFloat(payment.delivery_total || 0).toLocaleString()}</p>
                            <p className="font-bold text-primary">
                                <strong className='mr-2'>Sum Total:</strong> KES {parseFloat(payment.total || 0).toLocaleString()}
                            </p>

                        </div>
                    </div>


                    <div className="mb-6">
                        <h3 className="font-bold text-lg mb-3">Ordered Items ({payment.get_cart_items?.length || 0})</h3>
                        {payment.get_cart_items && payment.get_cart_items.length > 0 ? (
                            <div className="space-y-3">
                                {payment.get_cart_items.map((item) => (
                                    <div
                                        key={item.id}
                                        className="grid grid-cols-[auto_1fr_auto] gap-3 md:grid-cols-[auto_1fr_auto] items-start border p-3 rounded shadow-sm hover:shadow-md"
                                    >
                                        <div className="shrink-0 flex gap-3 items-center">
                                            <Link to={`/product/${item.product?.slug}`} className="shrink-0">
                                                <img
                                                    src={item.product.image}
                                                    alt={item.product.name}
                                                    className="w-16 h-16 object-cover rounded"
                                                />
                                            </Link>
                                            <div>
                                                {item.product.store_name && (
                                                    <p><strong className="mr-2">Store:</strong> {item.product.store_name}</p>
                                                )}
                                                {item.product.owner && (
                                                    <p><strong className="mr-2">Owner:</strong> {item.product?.owner_email || 'Admin'}</p>
                                                )}
                                            </div>
                                        </div>


                                        <div className="min-w-0">
                                            <p>
                                                <strong className="mr-2">Item Name:</strong>
                                                <span className="break-words">{item.product.name}</span>
                                            </p>

                                            {item.product.condition && (
                                                <p>
                                                    <strong className="mr-2">Condition:</strong>
                                                    <span>{item.product.condition}</span>
                                                </p>
                                            )}

                                            <p>
                                                Qty: {item.quantity} × KES {parseFloat(item.product.price).toLocaleString()} ={' '}
                                                <strong>KES {parseFloat(item.total).toLocaleString()}</strong>
                                            </p>
                                        </div>
                                        <div className="shrink-0 flex flex-col justify-start">
                                            <button
                                                disabled={user?.is_admin || user?.is_vendor}
                                                onClick={() => refundModal(item, item?.refund?.id ? 1 : 0)}
                                                className={item?.refund?.id ? 'btn btn-neutral' : 'btn btn-warning'}
                                            >
                                                <HiReceiptRefund className="mr-2" />
                                                {!(user?.is_admin || user?.is_vendor) && !item?.refund?.id && (
                                                    <span>Request </span>
                                                )}
                                                Refund
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <p className="text-gray-500 italic">No items found.</p>
                        )}
                    </div>


                    <div className="border-t pt-6">
                        <h3 className="font-bold text-lg mb-4">Update Order</h3>
                        <form onSubmit={handleSubmit} className="space-y-4">
                            <div className="form-control">
                                <label className="label">
                                    <span className="label-text">Payment Status</span>
                                </label>
                                <select
                                    disabled={user?.is_vendor}
                                    value={status}
                                    onChange={(e) => setStatus(e.target.value)}
                                    className="select select-bordered"
                                    required
                                >
                                    <option value="Pending">Pending</option>
                                    <option value="Paid">Paid</option>
                                    <option value="Failed">Failed</option>
                                    <option value="Refunded">Refunded</option>
                                </select>
                            </div>

                            <div className="form-control">
                                <label className="label">
                                    <span className="label-text">Delivery Status</span>
                                </label>
                                <select
                                    disabled={user?.is_vendor}
                                    value={deliveryStatus}
                                    onChange={(e) => setDeliveryStatus(e.target.value)}
                                    className="select select-bordered"
                                    required
                                >
                                    <option value="Ordered">Ordered</option>
                                    <option value="Processing">Processing</option>
                                    <option value="Out for Delivery">Out for Delivery</option>
                                    <option value="Delivered">Delivered</option>
                                    <option value="Returned">Returned</option>
                                </select>
                            </div>

                            {user?.is_admin && (
                                <div className="pt-4">
                                    <button
                                        type="submit"
                                        disabled={loading}
                                        className="btn btn-primary flex-1 md:flex-none w-full"
                                    >
                                        {loading ? (
                                            <>
                                                <span className="loading loading-spinner loading-sm mr-2"></span>
                                                Updating...
                                            </>
                                        ) : (
                                            'Update Order'
                                        )}
                                    </button>
                                </div>
                            )}
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OrderModal;